<template lang="pug">
  .ride-month-template()
    .app-use-logo(v-if="env.isEasyBikeApp && isOneCentRide")
      .app-use-logo-text APP专享
    .ride-card(:class="type +' '+ status" :style="isModal?borderRaduis:heightSmall")
      .card-logo(v-if="!isOneCentRide")
      .card-info
        .card-info-line-one
          span {{cardDetail.heading}}
          span(v-if="!isOneCentRide") {{cardDetail.title}}·{{cityNames}}
          span(v-else) {{cardDetail.title}}
          span(v-if="rideStatue===0&&isOpen") ·生效中
        .card-info-line-two
          span  {{cardDetail.subTitle}}
      .ride-num()
        .just-one-per-cent(v-if="isOneCentRide && !isOpen")
          HighlightText(
            text="单单{0.01}元"
            :normalStyle="normalStyle"
            :highlightStyle="highlightStyle")
        .have-day(v-if="rideDays>0&&cardsStatus===2")
          .small-sign 剩
          .big-num {{totalCardTimes?rideTimes:rideDays}}
          .small-sign {{totalCardTimes?'次':'天'}}
        .no-day(v-else-if="rideDays===0&&cardsStatus===2") 今日到期
        .can-use(v-else-if="showRideCardTouting&&isOpen"
          @click="goUse"
          :class="'can-use-v2'") {{env.isEasyBikeApp?'领取':'去APP使用'}}
      .card-status-info(v-if="status === statusEnum.waitForReceive")
        span {{cardMap[cardStatus]}}
      slot
  </template>
<script>
import { env } from '@hb/hbridge';
import { PropVersionMap } from '@/const/vip';
import { HighlightText } from '@hb/platformui-h5';
import { RIDE_CARD_STATUS } from '../../../consts';

const CARD_DETAIL_CONFIG = {
  bike: {
    title: '30天不限次卡',
    subTitle: '单笔抵120分钟',
    heading: '单车',
  },
  ebike: {
    title: '30天6次卡',
    subTitle: '单笔抵3元',
    heading: '助力车',
  },
  oneCentRide: {
    title: '30天不限次卡',
    subTitle: '全国通用 ｜前120分钟仅0.01元',
    heading: '单车',
  },
};

export default {
  name: 'RideMonthTemplate',
  components: {
    HighlightText,
  },
  props: {
    type: {
      type: String,
      default: 'bike',
    },
    status: {
      type: String,
      default: '',
    },
    totalCardDays: {
      type: Number,
      default: 0,
    },
    totalCardTimes: {
      type: Number,
      default: 0,
    },
    rideStatue: {
      type: Number,
      default: 0,
    },
    cityNames: {
      type: String,
      default: '全国通用',
    },
    rideFreeMinute: {
      type: String,
      default: '',
    },
    cardsStatus: {
      type: Number,
      default: 0,
    },
    rideTimes: {
      type: Number,
      default: 0,
    },
    rideDays: {
      type: Number,
      default: 0,
    },
    isOpen: {
      type: Boolean,
      default: false,
    },
    showRideCardTouting: {
      type: Boolean,
      default: false,
    },
    cardStatus: {
      type: Number,
      default: 0,
    },
    isModal: {
      type: Boolean,
      default: false,
    },
    propVersion: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      statusEnum: {
        receivable: 'receivable',
        waitForReceive: 'wait-for-receive',
      },
      env,
      cardMap: RIDE_CARD_STATUS,
      borderRaduis: 'border-radius: 0.1rem 0.1rem 0.1rem 0.1rem;',
      heightSmall: 'height: 0.66rem',
    };
  },
  inject: ['rideOneCentVersion'],
  computed: {
    isOneCentRide() {
      return this.rideOneCentVersion() === PropVersionMap.RIDE_ONE_CENT;
    },
    cardDetail() {
      const cardType = this.isOneCentRide ? 'oneCentRide' : this.type;
      const tempCardDetail = CARD_DETAIL_CONFIG[cardType] || CARD_DETAIL_CONFIG.ride;
      if (this.isOpen && this.rideCardInfoValue) {
        tempCardDetail.title = `${this.totalCardDays || 30}天${this.totalCardTimes || '不限'}次卡`;
      }
      return tempCardDetail;
    },
    normalStyle() {
      return {
        fontWeight: 500,
        fontSize: '0.15rem',
        color: '#fff',
      };
    },
    highlightStyle() {
      return {
        fontWeight: 400,
        fontSize: '0.2rem',
        color: '#fff',
        fontFamily: 'DIN Alternate Bold',
      };
    },
  },
  methods: {
    goUse() {
      this.$emit('goUse');
    },
  },

};
</script>
<style lang="less" scoped>
.ride-month-template {
  position: relative;

  .ride-card {
    border-radius: 0.1rem 0.1rem 0 0;
    height: 0.72rem;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .card-info {
      flex-grow: 1;

      .heading {
        height: 0.18rem;
        line-height: 0.18rem;
        border: 0.005rem solid white;
        border-radius: 0.04rem;
        margin-right: 0.06rem;
        padding: 0 0.04rem;
        font-size: 0.12rem;
        background: rgba(234, 246, 255, 0.2);
      }
    }

    &.wait-for-receive {
      background: #eff2f5;
      color: #6c747a;
      margin-top: 0.08rem;
    }

    .card-logo {
      width: 0.53rem;
      height: 100%;
      margin-right: 0.16rem;
    }

    &.receivable.bike {
      background: linear-gradient(223deg, #3bf 0%, #33a0ff 100%);
      color: white;

      .card-logo {
        background: url('https://m.hellobike.com/resource/gallery/61/8FQNAEvw07.png?x-oss-process=image/quality,q_80') left top no-repeat;
        background-size: 100% 100%;
      }
    }

    &.receivable.ebike {
      background: linear-gradient(223deg, #25c0f5 0%, #00afea 100%);
      color: white;

      .card-logo {
        background: url('https://m.hellobike.com/resource/gallery/61/80-OynoJPC.png?x-oss-process=image/quality,q_80') left top no-repeat;
        background-size: 100% 100%;
      }
    }

    &.receivable.oneCentRide {
      background-image: url('https://m.hellobike.com/c1ae489b15.png');
      background-size: 100% 100%;
      color: white;
      padding-left: 0.2rem;

      .card-logo {
        background: url('https://m.hellobike.com/resource/gallery/61/8FQNAEvw07.png?x-oss-process=image/quality,q_80') left top no-repeat;
        background-size: 100% 100%;
      }
    }

    &.wait-for-receive.bike {
      .card-logo {
        background: url('https://m.hellobike.com/resource/gallery/30/iGi5tDEW_Mask%20group.png?x-oss-process=image/quality,q_80') left top no-repeat;
        background-size: 100% 100%;
      }
    }

    &.wait-for-receive.ebike {
      .card-logo {
        background: url('https://m.hellobike.com/resource/gallery/30/88TQjcDG_Mask%20group%20(1).png?x-oss-process=image/quality,q_80') left top no-repeat;
        background-size: 100% 100%;
      }
    }

    &.wait-for-receive.oneCentRide {
      background-image: url('https://m.hellobike.com/c1ae489b15.png');
      background-size: 100% 100%;
      padding-left: 0.2rem;
    }

    .card-status-info {
      background: #b5c0cb;
      font-size: 0.12rem;
      color: white;
      align-self: flex-start;
      border-top-right-radius: 0.1rem;
      border-bottom-left-radius: 0.1rem;
      padding: 0 0.08rem;
      display: flex;
      white-space: nowrap;
      align-items: center;
    }

    .card-info-line-two {
      font-size: 0.12rem;
      color: #e6f4ff;
      opacity: 0.7;
    }

    .card-info-line-one {
      font-size: 0.15rem;
      display: flex;
      align-items: center;
      margin-bottom: 0.06rem;
      font-weight: 500;
    }

    .dot {
      content: '';
      display: inline-block;
      width: 0.04rem;
      height: 0.04rem;
      background: white;
      border-radius: 50%;
      margin: 0 0.04rem;
      white-space: nowrap;
    }

    .ride-num {
      position: absolute;
      top: 0.18rem;
      right: 0.2rem;
      font-family: PingFangSC-Medium, PingFang SC, sans-serif;
      font-size: 0.14rem;
      font-weight: 400;
      color: #fff;
      line-height: 0.36rem;

      .have-day {
        display: flex;

        .big-num {
          font-family: "DIN Alternate Bold", sans-serif;
          font-size: 0.26rem;
          font-weight: 500;
        }

        .small-sign {
          line-height: 0.42rem;
        }
      }

      .can-use-v2 {
        min-width: 0.74rem;
        height: 0.32rem;
        background: #fff;
        color: #08f;
        font-size: 0.15rem;
        text-align: center;
        border-radius: 0.26rem;
        line-height: 0.32rem;
      }
    }
  }

  .app-use-logo {
    position: absolute;
    right: 0;
    top: 0;
    width: 0.51rem;
    height: 0.17rem;
    background: linear-gradient(90deg, #fff5e2 0%, #ffcab7 100%);
    border: 0.005rem solid #fff;
    border-radius: 0 0.1rem 0 0.1rem;

    .app-use-logo-text {
      font-size: 0.1rem;
      color: #000;
      line-height: 0.17rem;
      text-align: center;
      font-weight: 600;
    }
  }
}
</style>
